import { useRef, useState, useEffect } from "react";
import { useUser } from "@services/UserContext";

export const useChatSessionManager = (conversationIdParam?: string) => {
  const { chatSessionId, setChatSessionId } = useUser();

  const [conversationId, setConversationId] = useState<string>("");
  const chatSessionIdRef = useRef<string | null>(chatSessionId);
  const conversationIdRef = useRef<string | null>(conversationIdParam || null);

  useEffect(() => {
    chatSessionIdRef.current = chatSessionId;
  }, [chatSessionId]);

  useEffect(() => {
    if (conversationIdParam) {
      setConversationId(conversationIdParam);
      conversationIdRef.current = conversationIdParam;
    }
  }, [conversationIdParam]);

  const resetSession = () => {
    chatSessionIdRef.current = null;
    conversationIdRef.current = null;
    setChatSessionId(null);
    setConversationId("");
  };

  return {
    chatSessionId,
    setChatSessionId,
    chatSessionIdRef,
    conversationId,
    setConversationId,
    conversationIdRef,
    resetSession,
  };
};
